import React from 'react'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { FlexAlign, FlexRow } from 'src/components/Reusable/Flex'
import { ComplianceFramework } from '@trustero/trustero-api-web/lib/audit/framework_pb'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { GridColumn } from '../../../components/Reusable/Grid'
import { formatTimestamp, hasDatePassed } from '../../../Utils/formatDate'
import { useInAudit } from '../../../context/AuditContext'
import { AuditIcon } from '../../../components/Icons/Basic/AuditIcon'
import { hasPendingAuditReport } from './AuditIndex.helpers'
import { ItemMenu } from './ItemMenu'
import { AuditRow } from './AuditRow'
import { MagentaP, StatusContainer } from './AuditIndexPage.styles'
import { EndDateSVG } from './AuditIndexGrid.styles'

export const AuditIndexItem = ({
  audit,
}: {
  audit: AuditRecord
}): JSX.Element => {
  const hasPermission = useCanPerformAction(CAPABILITY.CAN_UPDATE_AUDITS)
  const { auditId: currentAuditId } = useInAudit()
  const auditId = audit.getId()
  const isClosed = audit.getIsClosed()
  const name = audit.getName()
  const isInterval = audit.getIsInterval()
  const complianceFrameworksList = audit.getComplianceFrameworksList()
  const frameworkNames = complianceFrameworksList
    .map((f) => f.getName())
    .join(', ')
  const startDate = audit.getStartDate()
  const endDate = audit.getEndDate()
  const hasPendingReport = hasPendingAuditReport(audit)
  const isPastAudit = endDate && hasDatePassed(endDate)
  const startDay = startDate ? formatTimestamp(startDate) : ''
  const endDay = endDate ? formatTimestamp(endDate) : ''
  const hasProForma = complianceFrameworksList.some(
    (complianceFramework: ComplianceFramework) =>
      complianceFramework.getHasProForma(),
  )

  const showEndDay = isPastAudit ? (
    <p>
      <EndDateSVG /> {endDay}
    </p>
  ) : (
    <p>{endDay}</p>
  )

  return (
    <>
      <AuditRow
        auditId={audit.getId()}
        isSelected={auditId === currentAuditId}
        isClosed={audit.getIsClosed()}
      >
        <GridColumn>
          <AuditIcon />
        </GridColumn>
        <GridColumn>{name}</GridColumn>
        <GridColumn>{frameworkNames}</GridColumn>
        <GridColumn>
          {isInterval ? (
            <FlexRow align={FlexAlign.FLEX_START} gap={4}>
              <p>{startDay}</p>
              <p> - </p>
              {showEndDay}
            </FlexRow>
          ) : (
            <>{showEndDay}</>
          )}
        </GridColumn>
        <GridColumn>
          <StatusContainer>
            {isClosed ? 'Closed' : 'Open'}
            {hasPendingReport && <MagentaP>Upload Report</MagentaP>}
          </StatusContainer>
        </GridColumn>
        <GridColumn>
          {hasPermission && (
            <ItemMenu
              isClosed={isClosed}
              auditId={auditId}
              hasProForma={hasProForma}
            />
          )}
        </GridColumn>
      </AuditRow>
    </>
  )
}
